import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/services/login.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-password.component.html',
  styleUrls: ['./recovery-password.component.scss'],
})
export class RecoveryPasswordComponent implements OnInit {
  @Input() token: string = '';
  recovery: UntypedFormGroup

  constructor(
    private loginSv: LoginService,
    private uiSv: UiServices,
    private modalController: ModalController,
    private fb: UntypedFormBuilder,
    private trSv: TranslateService
  ) { }

  ngOnInit() {
    this.recovery = this.fb.group({
      email: ['', [
        Validators.required,
        Validators.pattern(/^[\w\.g]+@+[\w]+[.]+[\D]{2,10}$/)
      ]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    });
  }

  async reset(){
    try{
      const actual = this.recovery.get('newPassword').value;
      const repeat = this.recovery.get('confirmPassword').value;
      
      if(actual === repeat){
        this.recovery.value.token = this.token;
        await this.uiSv.showLoading();
        const res: any = await this.loginSv.postRecovery(this.recovery.value);
        if(res.status){
          await this.uiSv.loading.dismiss();
          this.closeModal();
          const tr = this.trSv.instant('LAS_CONTRASEÑA_SE_ACTUALIZO_CORRECTAMENTE_INICIA_SESION')
          this.uiSv.showToast(tr);
        }
      }else{
        const tr = this.trSv.instant('LAS_CONTRASEÑAS_NO_COINCIDEN')
        this.uiSv.showToast(tr);
      }

    }catch(err){
      await this.uiSv.loading.dismiss();
      const tr = this.trSv.instant('HA_OCURRIDO_UN_ERROR');
      this.uiSv.showToast(tr);
    }
  }

  closeModal(data?){
    this.modalController.dismiss(data);
  }
}
